import React from "react"
import { TouchableOpacity } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

/** Une rangée de boutons : côte à côte au large, empilée sur un téléphone. */
export const buttonRow = (compact) => ({
    flexDirection: compact ? "column" : "row",
    // Empilés, les boutons ne s'enroulent pas : dans une colonne, `wrap` fait
    // mesurer la largeur sur le plus large des boutons au lieu du conteneur —
    // ils s'arrêtaient donc avant le bord, et la hauteur devenait négociable au
    // point de rogner le libellé.
    flexWrap: compact ? "nowrap" : "wrap",
    alignItems: compact ? "stretch" : "flex-start",
})

/**
 * Bouton d'action d'une étape : discret, jamais un pavé.
 *
 * Il ne porte aucune marge propre — l'espacement appartient au conteneur, sans
 * quoi le bouton se décale dans le pied de l'étape, où il doit s'aligner avec
 * un lien.
 */
const StepButton = ({ label, icon, onPress, disabled, tone, filled, block }) => (
    <TouchableOpacity
        onPress={onPress}
        disabled={disabled}
        style={{
            flexDirection: "row",
            alignItems: "center",
            // Sur écran étroit les boutons occupent toute la largeur et
            // s'empilent : côte à côte, ils débordaient et retombaient en
            // décalé, chacun d'une largeur différente.
            alignSelf: block ? "stretch" : "flex-start",
            justifyContent: block ? "center" : "flex-start",
            // Empilé, le bouton ne se laisse pas comprimer par la colonne, sans
            // quoi son libellé se retrouve rogné en hauteur. La hauteur minimale
            // vaut aussi cible tactile confortable au doigt.
            flexShrink: 0,
            minHeight: block ? 46 : undefined,
            backgroundColor: filled ? tone : "transparent",
            // Un contour de deux pixels : à un pixel et demi en gris, le bouton
            // se confondait avec le fond.
            borderWidth: filled ? 0 : 2,
            borderColor: tone,
            borderRadius: 10,
            paddingVertical: block ? 13 : 9,
            paddingHorizontal: 15,
            marginRight: block ? 0 : 8,
            marginBottom: block ? 9 : 0,
            opacity: disabled ? 0.5 : 1,
        }}
    >
        {!!icon && (
            <FontAwesome5
                name={icon}
                size={11}
                color={filled ? theme.colors.white : tone}
                style={{ marginRight: 7 }}
            />
        )}
        <TextM color={filled ? theme.colors.white : tone} fontSize={13} fontWeight={"Bold"}>
            {label}
        </TextM>
    </TouchableOpacity>
)

export default StepButton
